export function fUnit(unit: string) {
  return unit.replace('^2', '\u00B2');
}

export function fPrice(price: number) {
  const parts = price.toString().split(',');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join(',');
}
